'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var countrySelector = exports.countrySelector = function countrySelector(_ref) {
  var country = _ref.country;
  return country;
};


//////////////////
// WEBPACK FOOTER
// ./js/selectors/CountrySelectors.js
// module id = 359
// module chunks = 3 4